import React from 'react';
import Page from '../components/Page';

const Maintenance = () => (
    <div>
        <div className="d-none d-lg-block">
            <Page className="maintenance d-flex flex-column">
                <div className="w-100 h-100 d-flex flex-column justify-content-center align-items-center content">
                    <h1 style={{fontWeight: "bold"}}>U N D E R&nbsp;&nbsp;M A I N T E N A N C E</h1>
                    <h4>ขออภัยในความไม่สะดวกค่ะ เว็บไซต์อยู่ในระหว่างการปรับปรุงประจำวันค่ะ</h4>
                </div>
                <div className="footer d-flex flex-column justify-content-end align-items-center pb-3">
                    &copy; BEAUTRIUM Co., Ltd. All Rights Reserved.
                </div>
            </Page>
        </div>
        <div className="d-block d-lg-none trendy-mobile">
            <Page className="maintenance d-flex flex-column">
                <div className="w-100 h-100 d-flex flex-column justify-content-center align-items-center content">
                    <h4 style={{fontWeight: "bold", textAlign: "center"}}>U N D E R<br/>M A I N T E N A N C E</h4>
                    <h6 style={{textAlign: "center", padding: "0 2% 0 2%"}}>ขออภัยในความไม่สะดวกค่ะ<br/>เว็บไซต์อยู่ในระหว่างการปรับปรุงประจำวันค่ะ</h6>
                </div>
                <div className="footer d-flex flex-column justify-content-end align-items-center pb-3">
                    &copy; BEAUTRIUM Co., Ltd. All Rights Reserved.
                </div>
            </Page>
        </div>
    </div>
)

export default Maintenance